import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "qs";
import { applyActionCode } from "firebase/auth";
import { ArrowRight } from "lucide-react";

import { auth } from "../../firebase.js";
import AuthLayout from "../../components/AuthLayout.js";
import Button from "../../components/Button.js";
import StatusPanel from "../../components/StatusPanel.js";

function VerifyEmail() {
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  // Voorkom dubbel inwisselen (StrictMode / re-render): de eenmalige oobCode
  // mag maar één keer worden toegepast.
  const attempted = useRef(false);

  useEffect(() => {
    async function verifyEmail() {
      if (attempted.current) return;
      attempted.current = true;

      const query = qs.parse(location.search, { ignoreQueryPrefix: true });
      const actionCode = query.oobCode;

      if (!actionCode) {
        setStatus("error");
        setError("Deze verificatielink is ongeldig.");
        return;
      }

      try {
        await applyActionCode(auth, actionCode);
        // Ververs de sessie zodat een eventueel ingelogde gebruiker direct als
        // geverifieerd geldt. Faalt dit (bv. geen sessie), dan is de verificatie
        // zelf toch al gelukt.
        try {
          if (auth.currentUser) await auth.currentUser.reload();
        } catch (_e) {}
        setStatus("success");
      } catch (err) {
        console.error(err);
        setStatus("error");
        setError("Deze link is verlopen of je e-mailadres is al geverifieerd.");
      }
    }

    verifyEmail();
  }, [location.search]);

  return (
    <AuthLayout>
      {status === "loading" && (
        <div className="flex items-center gap-3">
          <div className="w-5 h-5 border-2 border-accent border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-text-secondary">Bezig met verifiëren...</p>
        </div>
      )}

      {status === "success" && (
        <StatusPanel
          variant="success"
          title="E-mailadres bevestigd"
          description="Bedankt! Je e-mailadres is geverifieerd. Je kunt nu inloggen."
          actions={<Button label="Naar inloggen" onClick={() => navigate("/login")} icon={ArrowRight} />}
        />
      )}

      {status === "error" && (
        <StatusPanel
          variant="error"
          title="E-mailverificatie mislukt"
          description={error}
          actions={<Button label="Naar inloggen" onClick={() => navigate("/login")} icon={ArrowRight} />}
        />
      )}
    </AuthLayout>
  );
}

export default VerifyEmail;
